import React from "react";

const TrackingPolicy = () => {
    return <div>TrackingPolicy</div>;
};

export default TrackingPolicy;